/**
 * file : MyPage/Inquery/List.jsx
 * 설명 : 마이페이지 > 문의하기
*/

import $ from 'jquery';
import Info from '../Info';
import { Fnc, Url } from "common/globals";
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { Search, Insert } from "components/Common/ApiCall";
import { Paging, Spinner, DropFileZone } from "components/Common/Componentization";       

export default function List() {
  document.title = "문의보기";
  // 경로 지정 
  const navigate = useNavigate();
  // 입력 값
  const [value, setValue] = useState({
    images: []
  });
  // 값 할당
  const valInsert = (key, val) => { setValue({ ...value, [key]: val }) };
  // 데이터
  const [datas, setDatas] = useState();
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);
  // 조회 조건 
  const [searchWhere, setSearchWhere] = useState({
    per_page: 5
  });
  // 조회 조건 할당 
  const searchWherePut = (key, val) => { setSearchWhere(prevState => ({ ...prevState, [key]: val}))};
  // Toggle 관련
  const toggle = (target) => {
    $(".view").not(target).removeClass("open").next(".fold").removeClass("open");
    $(target).toggleClass("open").next(".fold").toggleClass("open")
  }
  // 상태에 따라 클래스 및 Text 지정
  const choice = (target) => {
    switch (target) {
      case 'S':
        return { text: '답변 완료', class: 'bg0' };
      case 'R':
        return { text: '재확인 요청', class: 'bg2' };
      case 'T':
        return { text: '내용 부족', class: 'bg6' };
      default:
        return { text: '미답변', class: 'bg1' };
    }
  }
  // 조회 핸들러 (CallBack으로 조회할 경우 사용)
  const handleSearch = () => {Search('/inquiry', setDatas, setDataLoading, searchWhere)}
  useEffect(() => {
    handleSearch()
  }, [searchWhere])
  // 데이터 추가 핸들러 (데이터를 삽입해야할때 사용)
  const handleInsert = (target) => {
    value['parent_idx'] = target;
    Insert('/inquiry/add', value, setDataLoading, () => {
      handleSearch()
      setValue({ images: [] })
      valInsert('contents', '')
    });
  }

  return (
    <>
      <Spinner show={dataLoading} />
      <div className="mypage_wrap">
        <div className="location">
          MY PAGE &nbsp; &gt; &nbsp; 나의 정보 &nbsp; &gt; &nbsp; 문의하기
			  </div>
        <Info />
        {/* 탭 */}
        <div className="mypage_content box_style1">
          <div className="tit">
            <h2>문의하기</h2>
            <Link to="/myPage/inqueryAdd" className="btn_basic bg2">질문하기</Link>
          </div>
          <div className="tab_mu">
            <div className="tab box_style1">
              <ul>
                <li onClick={() => navigate("/myPage/tournamentRequest")}>
                  토너먼트 신청내역
                </li>
                <li onClick={() => navigate("/myPage/Message")}>
                  쪽지함
                </li>
                <li onClick={() => navigate("/myPage/inquery")} className="active">
                  문의하기
                </li>
              </ul>
            </div>
          </div>
          {/* 테이블 */}
          <div className="table-container">
            <table className="fold-table table_style1 qna">
              <thead>
                <tr>
                  <th>NO</th>
                  <th>제목</th>
                  <th>작성일</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {
                  !Fnc.Empty(datas) && <>
                    {
                      datas.data.map((data , index) => (
                        <React.Fragment key={index}>
                          <tr className="view" onClick={(e) => {toggle(e.currentTarget);}}>
                            <td className="nu">{datas.currIndex - index}</td>
                            <td className="align_l"><span className="bg5 smallbox align_c mr_5">{data.type_name}</span> {data.title}</td>
                            <td>{Fnc.FormatDate(data.created_at, true)}</td>
                            <td><span className={`${choice(data.state).class}  smallbox`}>{choice(data.state).text}</span></td>
                          </tr>
                          <tr className="fold">
                            <td colSpan="5">
                              <div className="fold-content-qa align_l">
                                <div className="qa_box">
                                  <p className="tit">{data.title}</p>
                                  <p className='content'>{data.contents}</p>
                                  {
                                    !Fnc.Empty(data.file) && <>
                                      {
                                        data.file.map((f) => (
                                          <img src={`${Url.BoardImgUrl}/${f.uuid}.${f.filetype}`} alt={f.uuid} key={f.uuid} className='content-img'/>
                                        ))
                                      }
                                    </>
                                  }
                                </div>
                              </div>
                              {
                                !Fnc.Empty(data.comments) && <>
                                  {
                                    data.comments.map((comment, idx) => (
                                      <div className={`${comment.author_type === 'M' ? 'fold-content-ripple' : 'fold-content-answer'} align_l`} key={idx}>
                                        <div className={comment.author_type === 'M' ? 'qa_box' : 'answer_box'}>
                                          <p className="tit">{comment.author_type === 'M' ? `${data.title} 재문의` : 'TMT'}</p>
                                          <p className='content'>{comment.contents}</p>
                                          {
                                            !Fnc.Empty(comment.file) && <>
                                              {
                                                comment.file.map((cf) => (
                                                  <img src={`${Url.BoardImgUrl}/${cf.uuid}.${cf.filetype}`} alt={cf.uuid} key={cf.uuid} className='content-img'/>
                                                ))
                                              }
                                            </>
                                          }
                                        </div>
                                      </div>
                                    ))
                                  }
                                </>
                              }
                              <div className="comments">
                                <div className="input_textaea">
                                  <textarea
                                    placeholder="내용을 입력해 주세요"
                                    onChange={(e) => { valInsert('contents', e.target.value) }}
                                    value={value.contents}
                                  >
                                  </textarea>
                                </div>
                                <DropFileZone fileDatas={value.images} handleFile={setValue} />
                                <div className="btns_wrap mt_50 mb_50">
                                  <Link className="font_style1 btn_play application" onClick={() => handleInsert(data.idx)}>문의 등록</Link>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))
                    }
                  </>
                }
              </tbody>
            </table>
            {/* 페이징 */}
            { Fnc.Empty(datas) && <div className='table-no-data'>문의한 내역이 없어요</div> }
            <Paging pageData={datas} PageChange={searchWherePut} />
          </div>
        </div>
      </div>
    </>
  )    
}